'use client';
import { useStreamingStore } from '@/store/streaming';
import { VideoDeviceType } from '@/services/streaming.service';
import { MatchModelBase } from '@nf/types/odds';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAccountInfo } from '@/hooks/query/account';
import { useExternalScript } from '@nf/utils-common/hooks';
import { useEffect, useState } from 'react';
import  { VideoBase } from './video-base';


export const  MCDNBase = ({ device, match }: { device?: VideoDeviceType, match?: MatchModelBase }) => {
	const [streamingType, streamingSrc, streamingUrl, isPin, mcdnClientId] = useStreamingStore(
		state => [state.streamingType, state.streamingSrc, state.streamingUrl, state.isPin, state.mcdnClientId]
	);
	const [isSdkJsReady, setIsSdkJsReady] = useState(false);
	const [isMcdnPlayerReady, setIsMcdnPlayerReady] = useState(false);

	const McdnhlsSrc = 'https://jsdelivr.fusioncdn.com/npm/@mlytics/p2sp-sdk@latest/bundle/peripheral/player/videojs-hls.min.js';
	const McdnDriver = 'https://jsdelivr.fusioncdn.com/npm/@mlytics/p2sp-sdk@latest/bundle/driver.min.js';	

	const McdnhlsSrcStatus = useExternalScript(McdnhlsSrc);
	const McdnDriverSrcStatus = useExternalScript(McdnDriver);

	// console.log('HlsjsHlsPlugin', HlsjsHlsPlugin);
	useEffect(() => {
		if (!isSdkJsReady) return;
		if (McdnDriverSrcStatus === 'ready' && McdnhlsSrcStatus === 'ready') {
			setIsMcdnPlayerReady(true);
		}
	}, [McdnhlsSrcStatus, McdnDriverSrcStatus, isSdkJsReady]);

	useEffect(() => {
		const SdkJs = `https://sdkjs.fusioncdn.com/${mcdnClientId}-mlysdk.js`
		const MCDN_SDK_ID = 'MCDNSDK';
		if (!document.getElementById(MCDN_SDK_ID)) {
			const s = document.createElement('script');
			s.id = MCDN_SDK_ID;
			s.src = SdkJs;
			document.head.appendChild(s);
			s.async= true;
			setIsSdkJsReady(true);
		} else {
			setIsMcdnPlayerReady(true);
		}
	}, []);

	return (
		isMcdnPlayerReady ? <VideoBase device={device} /> :<></> 
	);
};